// src/components/atoms/landing/eyebrow-chip.tsx
import { cn } from "@/lib/utils";

type Tone = "mint" | "lilac" | "ink" | "white";

type EyebrowChipProps = {
  children: React.ReactNode;
  icon?: React.ReactNode;
  tone?: Tone;
  className?: string;
};

const toneClass: Record<Tone, string> = {
  mint: "bg-[#3DE3C2] text-brand-ink",
  lilac: "bg-brand-muted text-brand-ink",
  ink: "bg-brand-ink text-white",
  white: "bg-white text-brand-ink",
};

export function EyebrowChip({
  children,
  icon,
  tone = "mint",
  className,
}: EyebrowChipProps) {
  return (
    <span
      className={cn(
        "inline-flex h-7 items-center gap-2 rounded-full px-4 font-display text-xs font-medium tracking-[0.02em]",
        toneClass[tone],
        className,
      )}
    >
      {icon ? <span className="inline-flex">{icon}</span> : null}
      {children}
    </span>
  );
}
